import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AuthenticationManager from "../services/StorageJWT";

export default function MasterPage({ children }) {
  const location = useLocation(); // React Hook
  const [point, setPoint] = useState(0);
  var _auth = new AuthenticationManager();
  const navigate = useNavigate();
  const counter = async (minimum, maximum) => {
    for (let count = minimum; count <= maximum; count++) {
      setTimeout(() => {
        setPoint(count);
      }, 1000);
    }
  };

  useEffect(() => {
    if (_auth?._token?.point) counter(0, _auth._token.point);
  }, [_auth?._token?.point]);
  useEffect(() => {});
  return (
    <div className="master">
      <img id="frame" src="/images/frame.png" />
      <div className="box">
        <header className="rounded">
          {location.pathname == "/one" ||
          location.pathname == "/two" ||
          location.pathname == "/one/helps" ||
          location.pathname == "/two/helps" ||
          (location.pathname == "/" && _auth._token?.status == 1) ? (
            <div className="row align-items-center justify-content-between menu ">
              <div
                className="col d-flex align-items-center"
                role="button"
                onClick={() => navigate("/menu/points")}
              >
                <img src="/icons/point.svg" alt="" height={48} width={48} />

                <span
                  className=" d-flex justify-content-center align-items-center user-point w-100 "
                  role="button"
                >
                  {point}
                  <div className="ps-1">امتیاز</div>
                </span>
              </div>
              <div className="col text-center">
                <embed
                  src="/images/game/logo.svg"
                  type="image/svg+xml"
                  width="50px"
                  height={"50px"}
                />
              </div>
              <div className="col text-end">
                <img
                  src="/icons/user.svg"
                  className="w-auto floar"
                  role="button"
                  onClick={() => navigate("/menu")}
                />
              </div>
            </div>
          ) : null}

          {location.pathname == "/properties" ||
          location.pathname == "/menu" ||
          location.pathname == "/menu/profile" ||
          location.pathname == "/menu/assist" ||
          location.pathname == "/menu/games" ||
          location.pathname == "/menu/games/code" ||
          location.pathname == "/menu/messages" ||
          location.pathname == "/menu/points" ? (
            <img
              src="/images/game/logo.svg"
              alt=""
              className="logo"
              width="50px"
              height={"50px"}
            />
          ) : null}
        </header>
        <img src="/images/game/box.png" className="template" alt="" />
      </div>
      {children}
    </div>
  );
}
